import {ChangeDetectionStrategy, Component, computed, input, output, ViewEncapsulation} from '@angular/core';
import {SurveyMetricDimension} from '../../../../../../types/SurveyMetricDimension';

@Component({
  selector: 'app-cpru-survey-questions',
  templateUrl: './cpru-survey-questions.component.html',
  styleUrls: ['./cpru-survey-questions.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpruSurveyQuestionsComponent {
  dimension = input<SurveyMetricDimension>(null);
  name = input<string>(null);
  opened = input<boolean>(false);
  closePanel = output<boolean>();

  public dimensionDescription = computed<string>(() =>
    this.updateDimensionDescriptionAndAverageScore(this.dimension()?.name),
  );

  public closeQuestionsPanel(): void {
    this.closePanel.emit(true);
  }

  private updateDimensionDescriptionAndAverageScore(dimensionName: string): string {
    switch (dimensionName) {
      case 'Samlat omdöme':
        return `Patienternas helhetsupplevelse av vården hos <b>${this.name()}</b>
sett till upplevd effektivitet och utfall, omhändertagande och trygghet.`;
      case 'Helhetsintryck':
        return `Patienternas helhetsupplevelse av vården hos <b>${this.name()}</b> sett
till upplevd effektivitet och utfall, omhändertagande och trygghet.`;
      case 'Emotionellt stöd':
        return `Hur patienten upplever att personalen/behandlaren hos <b>${this.name()}</b>
är aktiv och lyhörd inför patientens oro, ångest, farhågor, rädsla och/eller smärta, samt upplevelsen av tillgänglighet och stöd.`;
      case 'Delaktighet och involvering':
        return `Patientens upplevelse av att vara involverad och delaktig i beslut gällande
sin vård hos <b>${this.name()}</b>.`;
      case 'Respekt och bemötande':
        return `Patientens upplevelse av <b>${this.name()}</b>s förmåga att anpassa bemötandet
utifrån individuella behov och förutsättningar.`;
      case 'Kontinuitet och koordinering':
        return `Patientens upplevelse av <b>${this.name()}</b>s förmåga till kontinuitet och
koordinering gällande hur väl patientens vård samordnas internt och externt.`;
      case 'Information och kunskap':
        return `Patientens upplevelse av hur väl <b>${this.name()}</b> kan informera/kommunicera
på ett sätt som är anpassat utifrån individuella förutsättningar och på ett proaktivt sätt.`;
      case 'Tillgänglighet':
        return `Patientens upplevelse av <b>${this.name()}</b>s tillgänglighet gällande närhet
och kontaktvägar, samt personalens tillgänglighet för patienten och anhöriga.`;
      default:
        return '';
    }
  }
}
